<template>
  <div>
    <!-- Header -->
    <Header
        :headerTitle="$t('m.submitOrder.title')"
        :hasBackBtn="false"
        :rightIconSrc="require('../assets/img/wode.png')"
        :onRightBtnClick="userCenter"
        :iconShow="true"
    ></Header>
    <div class="main-container" style="padding-top:10px; height: calc(100% - 50px)">
      <!-- section -->
      <section>
        <div class="cardId">
          <h6>{{resultList.licenseplate}}</h6>
        </div>
        <div class="cardAddress">
          <h5>{{$i18n.locale==='zh_CN' ? resultList.parkingAddress : resultList.parkingEnAddress}}</h5>
          <div v-if="resultList.parkingSpace && resultList.parkingSpace.selfService === 1" class="space-name">车位号: {{ resultList.parkingSpace.spaceName }}</div>
        </div>
        <div v-if="resultList.parkingSpace && resultList.parkingSpace.selfService === 1" class="cardAddress">
          <h6>终端信息</h6>
          <div class="equipment-desc-container">
            <div v-if="resultList.parkingSpace.describe1" class="equipment-desc">{{ resultList.parkingSpace.describe1 }}</div>
            <div v-if="resultList.parkingSpace.describe2" class="equipment-desc">{{ resultList.parkingSpace.describe2 }}</div>
            <div v-if="resultList.parkingSpace.describe3" class="equipment-desc">{{ resultList.parkingSpace.describe3 }}</div>
          </div>
          <h6 style="margin-top: 8px">价格信息</h6>
          <div class="space-name">{{ resultList.chargeUnitAmount }}元/度</div>
        </div>
        <div class="infoCard">
          <p class="borderba">{{$t('m.submitOrder.inTitle')}}</p>
          <div style="padding-top:5px">
            <h6>{{resultList.appointInTime}}</h6>
            <p style="margin-top: 16px;" v-if="$t('m.submitOrder.language')=='zh_CN'">{{$t('m.submitOrder.tips')}}</p>
            <p v-if="$t('m.submitOrder.language')=='en_US'">&nbsp;</p>
          </div>
          <h6 class="dateAppche">{{appointTime}}</h6>
          <p class="borderba">{{$t('m.submitOrder.outTitle')}}</p>
          <div style="border:0;">
            <h6>{{resultList.appointOutTime}}</h6>
            <!-- <p>
              离开停车场前，请找现场工作人员拿"
              <span style="color:#0066B1">出门卡</span>"
            </p> -->
          </div>
        </div>
        <p v-if="$t('m.submitOrder.language')=='en_US'" style=" font-size: 13px;color: #666;text-align:left">Please
          enter on time, in case no parking lot is available</p>
      </section>
      <!-- footer -->
      <footer>
        <p v-if="$t('m.submitOrder.language')=='zh_CN'">
          请在
          <span>{{resultList.cancelTime}}</span>之前完成支付,逾期订单自动取消
        </p>
        <p v-if="$t('m.submitOrder.language')=='en_US'">
          Please pay before <span>{{resultList.cancelTime}}</span>, otherwise the order will be cancelled automatically.
        </p>
        <b-btn v-b-modal.modal-center>{{$t('m.submitOrder.cancelButton')}}</b-btn>
        <button class="btn success paymentOrder" @click="wxPay">
          {{$t('m.submitOrder.goPay')}}
          <span>{{resultList.amount}}</span> {{$t('m.submitOrder.CNY')}}
        </button>
        <!-- 取消订单 modal -->
        <b-modal
            id="modal-center"
            class="cancelOrders"
            :cancel-title="$t('m.submitOrder.no')"
            :ok-title="$t('m.submitOrder.yes')"
            @ok="onCancelOrderConfirm"
        >
          <p
              class="my-4"
              style="margin-bottom:5px !important;padding:0 25px;font-size:15px;"
          >{{$t('m.submitOrder.cancelOrderTips')}}</p>
        </b-modal>
        <b-modal
            ref="selfOperation"
            class="cancelOrders"
            :ok-title="$t('m.submitOrder.yes')"
        >
          <p class="my-4"
             style="margin-bottom:5px !important;padding:0 25px;font-size:15px;"
          >{{$t('m.submitOrder.tipsTitle')}}</p>
          <p class="my-4"
             style="margin-bottom:5px !important;padding:0 25px;font-size:15px;"
          >{{$t('m.submitOrder.tipsConetnt')}}</p>
        </b-modal>

      </footer>
    </div>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
  import {
    cancelOrder,
    prePayOrderInfo,
    orderListByDetails,
    orderStatus,
    goPay
  } from "../api/order.js";
  import {dateAdd, formatDate, hourtoMinute} from "@/utils/DateFomatUtil";
  import {constants} from 'crypto';
  import { getBrowserType } from '@/utils/common.js'
  export default {
    name: "SubmitOrder",
    data() {
      return {
        orderId: "", //订单Id
        _resultList: {}, //数据
        get resultList() {
          return this._resultList;
        },
        set resultList(value) {
          this._resultList = value;
        },
        wxPayData: {},
        openId: "", //微信ID obgbnwSp8HfdbriuhcHMMx5Q4_2Y
        longitude: 0, //当前经度
        latitude: 0, //当前维度
        ostatus: null,
        cancelTime: '',//取消订单显示时间
        appointTime: "", //预约时间
        tipShow: "0", //是否提示
        tipType: "", //提示类型
        message: "" //提示信息
      };
    },
    methods: {
      // 用户中心
      userCenter: function () {
        if (this.ostatus != null) {
          clearInterval(this.ostatus);
        }
        setTimeout(()=> {
          this.$router.push("/userCenter");
        }, 1100);
      }, //取消订单
      onCancelOrderConfirm: function () {
        cancelOrder({orderId: this.orderId}).then(
            response => {
              if (response.data.status == 200) {
                if (this.ostatus != null) {
                  clearInterval(this.ostatus);
                }
                this.tipShow = "1" + Math.random() * 1000;
                this.message = this.$t('m.submitOrder.cancelSuccess');
                this.tipType = "success";
                setTimeout(() => {
                  this.$router.push("/");
                }, 1100);
              } else {
                if (this.ostatus != null) {
                  clearInterval(this.ostatus);
                }
                this.tipShow = "1" + Math.random() * 1000;
                this.tipType = "warning";
                this.message = response.data.message;
              }
            }
        );
      },
      //加载获取的数据
      loadPrePayOrderInfo: function () {
        setTimeout(() => {
          orderListByDetails({
            orderId: this.orderId,
            latitude: this.latitude,
            longitude: this.longitude
          }).then(
              response => {
                if (response.data.status != 200) {
                  this.tipShow = "1" + Math.random() * 1000;
                  this.tipType = "warning";
                  this.message = response.data.message;
                  return;
                }
                this.resultList = response.data.result;
                this.appointTime = hourtoMinute(this.resultList.appointTime, this.$t('m.dataTime.hour'), this.$t('m.dataTime.minute'));
                this.wxPayData = response.data.result.prePayInfoResponse.wechatPrePayInfo;
              },
              err => {
                reject(err);
              }
          );
        }, 200);
      },
      //支付操作
      wxPay() {
        goPay({orderId: this.orderId}).then(response => {

          if (response.data.status == 200) {
            this.wxPayData = response.data.result.prePayInfoResponse.wechatPrePayInfo;
			console.log(JSON.stringify(this.wxPayData))
            let browserType = getBrowserType()
			console.log('browserType:',browserType)
            if(browserType === 1) {
              // 微信内浏览器支付
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                      "WeixinJSBridgeReady",
                      this.onBridgeReady,
                      false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                  document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
                }
              } else {
                this.onBridgeReady();
              }
            } else if (browserType === 2) {
              // 微信外手机浏览器支付
              window.location.href = this.wxPayData.mwebUrl;
            } else if (browserType === 3) {
              // PC 浏览器支付, 暂不支持
            } else if (browserType === 4 || browserType === 5) {
              // 调用原生方法
              pay(response.data.result.prePayInfoResponse.orderNo, {
                packageVal: 'Sign=WXPay',
                appid: this.wxPayData.appId,
                sign: this.wxPayData.sign,
                partnerid: this.wxPayData.prePayId,
                prepayid: this.wxPayData.partnerId,
                noncestr: this.wxPayData.nonceStr,
                timestamp: this.wxPayData.timestamp
              }, 4)
            }
          }
        });
      },
      // 微信的信息
      onBridgeReady() {
        WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: this.wxPayData.appId, //公众号名称，由商户传入
              timeStamp: this.wxPayData.timestamp, //时间戳，自1970年以来的秒数
              nonceStr: this.wxPayData.nonceStr, //随机串
              package: this.wxPayData.extra,
              signType: "HMACSHA256", //微信签名方式：
              paySign: this.wxPayData.sign
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
              }
              if (res.err_msg == "get_brand_wcpay_request:cancel") {
              }
              if (res.err_msg == "get_brand_wcpay_request:fail") {
              }
            }
        );
      },
      //轮询订单状态
      orderStatus() {
        let this_s = this;
        this.ostatus = setInterval(function () {
          orderStatus({orderId: this_s.orderId}).then(response => {
            let data = response.data;
            if (data.status == 200) {
              if (data.result.status == 2) {
                var type = 1;
                this_s.$router.push(
                    "/StaySubmitOrder/" + this_s.orderId + "/" + type
                );
                clearInterval(this_s.ostatus);
              } else if (data.result.status == 4) {
                this_s.$router.back();
                clearInterval(this_s.ostatus);
              }
            } else {
              if (this.ostatus != null) {
                clearInterval(this.ostatus);
              }
              this.tipShow = "1" + Math.random() * 1000;
              this.tipType = "warning";
              this.message = response.data.message;
            }
          });
        }, 1000);
      }
    }, //页面缓存后每次都会调用
    created() {
      this.orderId = this.$route.params.orderId;
      this.orderStatus();
    }, mounted() {
      this.loadPrePayOrderInfo();
    },
    //页面离开事件
    destroyed() {
      if (this.ostatus != null) {
        clearInterval(this.ostatus);
      }
    }
  };
</script>
<style scoped>
  section {
    margin-bottom: 24px;
  }

  section .cardId {
    border-bottom: 2px solid #efefef;
    text-align: left;
  }

  section .cardAddress {
    padding: 20px 0;
    text-align: left;
    border-bottom: 2px solid #efefef;
  }

  section .cardAddress p {
    font-size: 13px;
    width: 85%;
    display: inline-block;
    color: #666;
  }

  section .cardAddress .equipment-desc-container {
    display: flex !important;
    justify-content: left;
    align-items: center;
    flex-direction: column;
    margin: 8px 0 16px 0;
  }

  section .infoCard {
    text-align: left;
    padding: 20px 0;
    padding-bottom: 25px;
    border-bottom: 2px solid #efefef;
  }

  section .infoCard .dateAppche {
    padding-top: 18px;
    color: #0066B1;
    padding-left: 5px;
  }

  section .infoCard .borderba {
    background-color: #0066B1;
    border-radius: 15px;
    display: inline-block;
    padding: 2px 13px;
    color: #fff;
    font-size: 14px;
    /* margin-top: 18px; */
    /* margin-top: 11px; */
    margin-top: 8px;
  }

  section .infoCard div {
    display: inline-block;
    text-align: right;
    float: right;
    width: 73%;
    margin-top: 4px;
    border-bottom: 2px solid #efefef;
  }

  section .infoCard div p {
    font-size: 13px;
    color: #666;
    padding-bottom: 10px;
  }


  footer {
    bottom: 0px;
    padding: 0 5%;
  }

  footer p {
    color: #0066B1;
    font-size: 13px;
  }

  footer p span {
    font-size: 18px;
  }

  footer button {
    width: 47%;
  }


  footer .paymentOrder {
    color: #fff;
    background-color: #0066B1;
    margin-left: 6.2125px;
  }
  .space-name {
    font-size: 24px;
    font-weight: 500;
    color: #0061B1;
    line-height: 24px;
  }
  .equipment-desc {
    width: 100%;
    text-align: left;
  }
</style>


